<template>
    <page-shell
        title="Create booking"
        subtitle="Create a booking for an X-Cube. First select an active X-Cube; the rest of the form follows."
    >
        <spinner :loading="loading" text="Creating booking..."></spinner>
        <booking-form :locations="locations" v-model="booking">
            <el-form-item label="">
                <el-button @click="saveBooking">Submit booking</el-button>
            </el-form-item>
        </booking-form>
    </page-shell>
</template>

<script setup>
import { Message } from "element-ui";
import { onMounted, ref } from "vue";
import * as Sentry from "@sentry/vue";
import Spinner from "../shared/Spinner.vue";
import { getUserLocationsSimple } from "../../api/graphql/locations";
import { createBooking } from "../../api/rest";
import { useRouter } from "vue-router/composables";
import BookingForm from "../booking/BookingForm.vue";
import PageShell from "../shared/PageShell.vue";

const loading = ref(false);
const locations = ref([]);

const router = useRouter();

const createEmptyBooking = () => {
    let uuid = new Date().getTime();
    if (self.crypto.randomUUID) {
        uuid = self.crypto.randomUUID();
    }
    const code = `HUB-${uuid}`;
    return {
        code,
        name: "",
        email: "",
        team_1_name: "",
        team_1_size: 1,
        language: "nl",
        xcube_id: null,
        phone_number: "",
        event_datetime: new Date(),
    };
};

const booking = ref(createEmptyBooking());

onMounted(async () => {
    locations.value = await getUserLocationsSimple();
});

const saveBooking = async () => {

    const saveData = {
        ...booking.value,
        event_datetime: booking.value.event_datetime,
        xcube_id: Number.parseInt(booking.value.xcube_id),
        experience_id: Number.parseInt(booking.value.experience_id),
    }

    try {
        loading.value = true;
        const newBooking = await createBooking(saveData);
        Message.success({ message: "Booking Created" });
        router.push({ name: 'view-booking', params: { id: newBooking.id } });
    } catch (e) {
        Message.error({ message: `Error creating booking: ${e.message}` });
        Sentry.captureException(e);
    } finally {
        loading.value = false;
    }
};
</script>
